import React, { ImgHTMLAttributes, useEffect, useState } from "react";

type SafeImageProps = ImgHTMLAttributes<HTMLImageElement>;

export default function SafeImage({ src, alt = "", ...props }: SafeImageProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) return null;

  return (
    <img
      {...props}
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
    />
  );
}
